import { render } from "./DoubleButtonChoice.vue?vue&type=template&id=23b451ef&scoped=true"
import script from "./DoubleButtonChoice.vue?vue&type=script&lang=js"
export * from "./DoubleButtonChoice.vue?vue&type=script&lang=js"

import "./DoubleButtonChoice.vue?vue&type=style&index=0&id=23b451ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b451ef"]])

export default __exports__